// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hris-dashboard-page .page-title {
  color: #1f2b3d;
  font-size: 22px;
  font-weight: 750;
  letter-spacing: 0;
}

.hris-competency-panel,
.hris-chart-card,
.hris-roster-card {
  border: 1px solid #e1e9ef;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 2px 9px rgba(41, 73, 102, 0.035);
}

.hris-competency-panel {
  padding: 20px 22px 22px;
}

.hris-competency-heading,
.hris-chart-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.hris-competency-heading {
  margin-bottom: 16px;
}

.hris-competency-heading h3,
.hris-chart-card__header h4 {
  margin: 0;
  color: #2d3b4d;
  font-size: 17px;
  font-weight: 750;
  letter-spacing: 0;
}

.hris-competency-heading p,
.hris-chart-card__header p,
.hris-chart-card__header span {
  margin: 4px 0 0;
  color: #7c8ea2;
  font-size: 13px;
}

.hris-data-pill {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  border-radius: 5px;
  background: #eaf7f6;
  color: #237a85;
  padding: 5px 9px;
  font-size: 12px;
  font-weight: 750;
  white-space: nowrap;
}

.hris-data-pill--demo {
  background: #fff4e7;
  color: #b15e00;
}

.hris-competency-mini-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.hris-competency-mini {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  border: 1px solid #e5edf2;
  border-radius: 7px;
  padding: 14px;
  background: #fbfdfe;
}

.hris-competency-mini > span {
  display: inline-grid;
  place-items: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  border-radius: 7px;
  background: #e7f5f4;
  color: #16837d;
}

.hris-competency-mini small {
  display: block;
  color: #7c8ea2;
  font-size: 12px;
}

.hris-competency-mini strong {
  display: block;
  color: #1f2b3d;
  font-size: 22px;
  line-height: 1.1;
}

.hris-competency-mini--blue > span { background: #eaf3fc; color: #2d7dd2; }
.hris-competency-mini--green > span { background: #e8f7ef; color: #15945f; }
.hris-competency-mini--purple > span { background: #f1ebfb; color: #8c5ad8; }
.hris-competency-mini--orange > span { background: #fff4e7; color: #ca7b20; }

.hris-chart-card {
  height: 100%;
  padding: 18px 20px;
}

.hris-chart-card .apexcharts-canvas {
  margin: 0 auto;
}

.hris-chart-empty {
  display: grid;
  min-height: 240px;
  place-items: center;
  color: #8795a8;
  font-size: 13px;
}

.hris-donut-legend {
  display: grid;
  gap: 6px;
  margin-top: 6px;
}

.hris-donut-legend__item {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 6px;
}

.hris-donut-legend__item:hover {
  background: #f6f8fa;
}

.hris-donut-legend__dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  flex: 0 0 10px;
}

.hris-donut-legend__label {
  overflow: hidden;
  color: #4b5d73;
  font-size: 12.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hris-donut-legend__value {
  color: #1f2b3d;
  font-size: 12.5px;
  font-weight: 750;
  white-space: nowrap;
}

.hris-donut-legend__value em {
  color: #8795a8;
  font-size: 11.5px;
  font-style: normal;
  font-weight: 600;
}

.hris-matrix {
  overflow-x: auto;
  padding-bottom: 2px;
}

.hris-matrix-card {
  overflow: hidden;
}

.hris-matrix__row {
  /* grid-template-columns is set inline per-render (matrixGridStyle in index.jsx) —
     sized to however many standards actually have approved competency data, instead
     of a fixed repeat(6, ...) that left empty tracks (and a phantom scrollbar) whenever
     fewer than 6 standards were covered. */
  display: grid;
  border-bottom: 1px solid #edf2f7;
}

.hris-matrix__row:last-child {
  border-bottom: 0;
}

.hris-matrix__row > span,
.hris-matrix__row > strong {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 10px;
  color: #4b5d73;
  font-size: 12px;
  text-align: center;
}

.hris-matrix__row:not(.hris-matrix__row--head):nth-child(even) {
  background: #fafcfd;
}

.hris-matrix__row:not(.hris-matrix__row--head):hover {
  background: #f2f8f7;
}

.hris-matrix__row > strong {
  justify-content: flex-start;
  color: #2d3b4d;
  font-size: 13px;
  font-weight: 750;
  text-align: left;
}

.hris-matrix__row--head > span {
  min-height: 38px;
  background: #f6f8fa;
  color: #718098;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: .06em;
  text-transform: uppercase;
}

.hris-matrix__row span.is-covered,
.hris-matrix__row span.is-empty {
  background: transparent;
}

.hris-matrix__row span.is-covered svg {
  display: inline-flex;
  width: 22px;
  height: 22px;
  padding: 4px;
  color: #fff;
  background: #16837d;
  border-radius: 999px;
}

.hris-matrix__row span.is-empty {
  color: #c3ccd6;
  font-size: 13px;
}

.hris-matrix__count {
  color: #16837d !important;
  font-weight: 800;
}

.hris-matrix__role {
  justify-content: flex-start !important;
  color: #607086 !important;
  text-align: left !important;
}

.hris-top-people__list {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.hris-top-people__item {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 36px;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e5edf2;
  border-radius: 7px;
  background: #fbfdfe;
}

.hris-top-people__item > span {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #eaf7f6;
  color: #237a85;
  font-size: 12px;
  font-weight: 800;
}

.hris-top-people__item strong,
.hris-top-people__item small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hris-top-people__item strong {
  color: #2d3b4d;
  font-size: 13px;
}

.hris-top-people__item small {
  color: #7c8ea2;
  font-size: 11px;
}

.hris-top-people__item b {
  justify-self: end;
  color: #1f2b3d;
  font-size: 18px;
}

.hris-roster-card .card-header,
.hris-roster-card .card-body {
  padding-left: 20px;
  padding-right: 20px;
}

.hris-roster-card .table {
  margin-bottom: 0;
}

.hris-roster-card .table thead th {
  background: #f6f8fa;
  color: #718098;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: .06em;
  text-transform: uppercase;
}

.hris-roster-more {
  display: flex;
  justify-content: center;
  padding: 8px 0 0;
}

@media (max-width: 1199.98px) {
  .hris-competency-mini-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575.98px) {
  .hris-competency-panel {
    padding: 16px;
  }

  .hris-competency-heading,
  .hris-chart-card__header {
    display: block;
  }

  .hris-data-pill {
    margin-top: 10px;
  }

  .hris-competency-mini-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HRIS/Dashboard/HRISDashboard.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,qCAAqC,mBAAmB,EAAE,cAAc,EAAE;AAC1E,sCAAsC,mBAAmB,EAAE,cAAc,EAAE;AAC3E,uCAAuC,mBAAmB,EAAE,cAAc,EAAE;AAC5E,uCAAuC,mBAAmB,EAAE,cAAc,EAAE;;AAE5E;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;2CAGyC;EACzC,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".hris-dashboard-page .page-title {\n  color: #1f2b3d;\n  font-size: 22px;\n  font-weight: 750;\n  letter-spacing: 0;\n}\n\n.hris-competency-panel,\n.hris-chart-card,\n.hris-roster-card {\n  border: 1px solid #e1e9ef;\n  border-radius: 7px;\n  background: #fff;\n  box-shadow: 0 2px 9px rgba(41, 73, 102, 0.035);\n}\n\n.hris-competency-panel {\n  padding: 20px 22px 22px;\n}\n\n.hris-competency-heading,\n.hris-chart-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.hris-competency-heading {\n  margin-bottom: 16px;\n}\n\n.hris-competency-heading h3,\n.hris-chart-card__header h4 {\n  margin: 0;\n  color: #2d3b4d;\n  font-size: 17px;\n  font-weight: 750;\n  letter-spacing: 0;\n}\n\n.hris-competency-heading p,\n.hris-chart-card__header p,\n.hris-chart-card__header span {\n  margin: 4px 0 0;\n  color: #7c8ea2;\n  font-size: 13px;\n}\n\n.hris-data-pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  border-radius: 5px;\n  background: #eaf7f6;\n  color: #237a85;\n  padding: 5px 9px;\n  font-size: 12px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.hris-data-pill--demo {\n  background: #fff4e7;\n  color: #b15e00;\n}\n\n.hris-competency-mini-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.hris-competency-mini {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  border: 1px solid #e5edf2;\n  border-radius: 7px;\n  padding: 14px;\n  background: #fbfdfe;\n}\n\n.hris-competency-mini > span {\n  display: inline-grid;\n  place-items: center;\n  flex: 0 0 38px;\n  width: 38px;\n  height: 38px;\n  border-radius: 7px;\n  background: #e7f5f4;\n  color: #16837d;\n}\n\n.hris-competency-mini small {\n  display: block;\n  color: #7c8ea2;\n  font-size: 12px;\n}\n\n.hris-competency-mini strong {\n  display: block;\n  color: #1f2b3d;\n  font-size: 22px;\n  line-height: 1.1;\n}\n\n.hris-competency-mini--blue > span { background: #eaf3fc; color: #2d7dd2; }\n.hris-competency-mini--green > span { background: #e8f7ef; color: #15945f; }\n.hris-competency-mini--purple > span { background: #f1ebfb; color: #8c5ad8; }\n.hris-competency-mini--orange > span { background: #fff4e7; color: #ca7b20; }\n\n.hris-chart-card {\n  height: 100%;\n  padding: 18px 20px;\n}\n\n.hris-chart-card .apexcharts-canvas {\n  margin: 0 auto;\n}\n\n.hris-chart-empty {\n  display: grid;\n  min-height: 240px;\n  place-items: center;\n  color: #8795a8;\n  font-size: 13px;\n}\n\n.hris-donut-legend {\n  display: grid;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.hris-donut-legend__item {\n  display: grid;\n  grid-template-columns: 10px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 8px;\n  border-radius: 6px;\n}\n\n.hris-donut-legend__item:hover {\n  background: #f6f8fa;\n}\n\n.hris-donut-legend__dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  flex: 0 0 10px;\n}\n\n.hris-donut-legend__label {\n  overflow: hidden;\n  color: #4b5d73;\n  font-size: 12.5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.hris-donut-legend__value {\n  color: #1f2b3d;\n  font-size: 12.5px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.hris-donut-legend__value em {\n  color: #8795a8;\n  font-size: 11.5px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.hris-matrix {\n  overflow-x: auto;\n  padding-bottom: 2px;\n}\n\n.hris-matrix-card {\n  overflow: hidden;\n}\n\n.hris-matrix__row {\n  /* grid-template-columns is set inline per-render (matrixGridStyle in index.jsx) —\n     sized to however many standards actually have approved competency data, instead\n     of a fixed repeat(6, ...) that left empty tracks (and a phantom scrollbar) whenever\n     fewer than 6 standards were covered. */\n  display: grid;\n  border-bottom: 1px solid #edf2f7;\n}\n\n.hris-matrix__row:last-child {\n  border-bottom: 0;\n}\n\n.hris-matrix__row > span,\n.hris-matrix__row > strong {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 8px 10px;\n  color: #4b5d73;\n  font-size: 12px;\n  text-align: center;\n}\n\n.hris-matrix__row:not(.hris-matrix__row--head):nth-child(even) {\n  background: #fafcfd;\n}\n\n.hris-matrix__row:not(.hris-matrix__row--head):hover {\n  background: #f2f8f7;\n}\n\n.hris-matrix__row > strong {\n  justify-content: flex-start;\n  color: #2d3b4d;\n  font-size: 13px;\n  font-weight: 750;\n  text-align: left;\n}\n\n.hris-matrix__row--head > span {\n  min-height: 38px;\n  background: #f6f8fa;\n  color: #718098;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: .06em;\n  text-transform: uppercase;\n}\n\n.hris-matrix__row span.is-covered,\n.hris-matrix__row span.is-empty {\n  background: transparent;\n}\n\n.hris-matrix__row span.is-covered svg {\n  display: inline-flex;\n  width: 22px;\n  height: 22px;\n  padding: 4px;\n  color: #fff;\n  background: #16837d;\n  border-radius: 999px;\n}\n\n.hris-matrix__row span.is-empty {\n  color: #c3ccd6;\n  font-size: 13px;\n}\n\n.hris-matrix__count {\n  color: #16837d !important;\n  font-weight: 800;\n}\n\n.hris-matrix__role {\n  justify-content: flex-start !important;\n  color: #607086 !important;\n  text-align: left !important;\n}\n\n.hris-top-people__list {\n  display: grid;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.hris-top-people__item {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr) 36px;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  border: 1px solid #e5edf2;\n  border-radius: 7px;\n  background: #fbfdfe;\n}\n\n.hris-top-people__item > span {\n  display: inline-grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  background: #eaf7f6;\n  color: #237a85;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.hris-top-people__item strong,\n.hris-top-people__item small {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.hris-top-people__item strong {\n  color: #2d3b4d;\n  font-size: 13px;\n}\n\n.hris-top-people__item small {\n  color: #7c8ea2;\n  font-size: 11px;\n}\n\n.hris-top-people__item b {\n  justify-self: end;\n  color: #1f2b3d;\n  font-size: 18px;\n}\n\n.hris-roster-card .card-header,\n.hris-roster-card .card-body {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.hris-roster-card .table {\n  margin-bottom: 0;\n}\n\n.hris-roster-card .table thead th {\n  background: #f6f8fa;\n  color: #718098;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: .06em;\n  text-transform: uppercase;\n}\n\n.hris-roster-more {\n  display: flex;\n  justify-content: center;\n  padding: 8px 0 0;\n}\n\n@media (max-width: 1199.98px) {\n  .hris-competency-mini-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 575.98px) {\n  .hris-competency-panel {\n    padding: 16px;\n  }\n\n  .hris-competency-heading,\n  .hris-chart-card__header {\n    display: block;\n  }\n\n  .hris-data-pill {\n    margin-top: 10px;\n  }\n\n  .hris-competency-mini-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
